import React, { useState, useEffect } from 'react';
import Axios from '../../Components/Axios/Axios';
import Auth from '../../Components/Auth/Auth';
import { useHistory } from 'react-router-dom';
import { USER_KEY } from '../../Constants/index';
import { Button, Grid, Paper, InputAdornment, TextField, Autocomplete, MenuItem, keyframes } from '@mui/material';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import FadeLoader from "react-spinners/FadeLoader";
import icon_success from '../../Images/Icons/success.png';
import icon_failed from '../../Images/Icons/error.png';
import dateFormat from 'dateformat';

function CheckList({ refresh }) {
    // For History
    const history = useHistory();

    // Set Loading
    const [loading, setLoading] = useState(false);

    // For Set Style Paper
    const paperStyle = { padding: 20, width: 'auto' }

    // For Get Current Date
    let _today = new Date();
    let _day = _today.getDate().toString();
    let _month = (_today.getMonth() + 1).toString();
    let _year = _today.getFullYear().toString();
    let _conDay = (_day.length == 2) ? _day : '0' + _day;
    let _conMonth = (_month.length == 2) ? _month : '0' + _month;
    let _showDate = _conDay + "/" + _conMonth + "/" + _year;

    //  For Day of Week Numbers
    let _charDay = _today.getDay();
    if (_charDay == 1) {
        _charDay = "ວັນຈັນ";
    } else if (_charDay == 2) {
        _charDay = "ວັນອັງຄານ";
    } else if (_charDay == 3) {
        _charDay = "ວັນພຸດ";
    } else if (_charDay == 4) {
        _charDay = "ວັນພະຫັດ";
    } else if (_charDay == 5) {
        _charDay = "ວັນສຸກ";
    } else if (_charDay == 6) {
        _charDay = "ວັນເສົາ";
    } else {
        _charDay = "ວັນອາທິດ";
    }

    // For get Employee Check-in Data
    const [dataCheckIn, setDataCheckIn] = useState([]);
    const [dataProv, setDataProv] = useState("");
    const [dataSite, setDataSite] = useState("");

    // Get Province and Site from Select
    const [selProv, setSelProv] = useState([]);
    const [selSite, setSelSite] = useState([]);
    const [foundSite, setFoundSite] = useState([]);
    const [selSiteID, setSelSiteID] = useState("");

    // Get data to Check-in
    const [provName, setProvName] = useState("");
    const [siteName, setSiteName] = useState("");
    const [dataCounter, setDataCounter] = useState([]);
    const [selCounter, setSelCounter] = useState("");
    const [inpUser, setInpUser] = useState("");

    // For get data from user login
    const tokenData = JSON.parse(localStorage.getItem(USER_KEY));
    const token = tokenData.token;
    const _empID = tokenData.emp_info[0].emp_id
    const _empCode = tokenData.emp_info[0].emp_code
    const _empName = tokenData.emp_info[0].fNameLao + " " + tokenData.emp_info[0].lNameLao
    const _empGender = tokenData.emp_info[0].emp_gender

    let _empGen;
    if (_empGender == 'F') {
        _empGen = "ທ່ານນາງ"
    } else {
        _empGen = "ທ່ານ"
    }
    const _empFull = _empGen + " " + _empName;

    // for Loading Data
    const loadData = async () => {
        setLoading(true)

        try {
            await Axios.post("Emp/Check_in/Date", { "employee_id": _empID }, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                // Check token Expired
                if (res.data.result_code == '403') {
                    Auth.logout(() => {
                        history.push("/");
                    });
                }

                if (res.data.result_code == "200") {
                    setDataCheckIn(res.data.emp_check_in_list)
                    let cycle = res.data.emp_check_in_list.length;
                    setDataProv(res.data.emp_check_in_list[cycle - 1].prov_name)
                    setDataSite(res.data.emp_check_in_list[cycle - 1].site_name)
                }
            })
        } catch (error) {
            // console.log(error)
        }

        // All Province Data
        await Axios.get("Province/All/Active", { headers: { Authorization: `Bearer ${token}` } }).then(res => {
            // Check token Expired
            if (res.data.result_code == '403') {
                Auth.logout(() => {
                    history.push("/");
                });
            }

            if (res.data.result_code == '200') {
                setSelProv(res.data.province_list)
            }
        })

        // All Site Data
        await Axios.get("Site/All/Active", { headers: { Authorization: `Bearer ${token}` } }).then(res => {
            // Check token Expired
            if (res.data.result_code == '403') {
                Auth.logout(() => {
                    history.push("/");
                });
            }

            if (res.data.result_code == '200') {
                setSelSite(res.data.site_list)
            }
        })

        setTimeout(() => {
            setLoading(false)
        }, 500);
    }

    useEffect(() => {
        loadData()
    }, [refresh])

    // For Dialog Check-in / Check-out / Breake
    const [openSelectSite, setOpenSelectSite] = useState(false);
    const [openCheckIn, setOpenCheckIn] = useState(false);
    const [openBreakeOn, setOpenBreakeOn] = useState(false);
    const [openBreakeOff, setOpenBreakeOff] = useState(false);
    const [openCheckOut, setOpenCheckOut] = useState(false);

    // For Any Alert Success/Failed
    const [openErrorCounter, setOpenErrorCounter] = useState(false);
    const [openCheckInSuccess, setOpenCheckInSuccess] = useState(false);
    const [openCheckInFailed, setOpenCheckInFailed] = useState(false);
    const [openOutSite, setOpenOutSite] = useState(false);
    const [openBreakeONSuccess, setOpenBreakeONSuccess] = useState(false);
    const [openBreakeONFailed, setOpenBreakeONFailed] = useState(false);
    const [openBreakeOFFSuccess, setOpenBreakeOFFSuccess] = useState(false);
    const [openBreakeOFFFailed, setOpenBreakeOFFFailed] = useState(false);
    const [openCheckOutSuccess, setOpenCheckOutSuccess] = useState(false);
    const [openCheckOutFailed, setOpenCheckOutFailed] = useState(false);

    // Fouction for Filter Counter by Province
    const filterProvince = (e) => {
        setFoundSite([]);
        setSelSiteID("");
        const keyword = e.target.value;

        // Set Found Site to Select
        if (keyword !== '') {
            const results = selSite?.filter((allSite) => {
                return allSite.prov_name.startsWith(keyword);
            });
            setFoundSite(results);
        } else {
            setFoundSite(selSite);
        }
    }

    // Fouction for Filter Side ID by Select Site
    const filterSite = (e) => {
        const keyword = e.target.value;
        setSelSiteID(keyword)
    }

    // Function for Check-in
    const checkIN = async () => {
        if (selSiteID != "") {
            // Set site_id
            let posData = {
                "site_id": selSiteID,
            }

            try {
                await Axios.post("Find/Site/Check_in", posData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "201") {
                        setOpenOutSite(true)
                    } else if (res.data.result_code == "202") {
                        setOpenErrorCounter(true)
                    } else {
                        setDataCounter(res.data.counter_list)
                        setProvName(res.data.site_info[0].prov_name)
                        setSiteName(res.data.site_info[0].site_name)
                        setOpenSelectSite(false)
                        setOpenCheckIn(true)
                    }
                })
            } catch (error) {
                // console.log(error)
            }
        }
    }

    const saveCheckIN = async () => {
        if (selCounter != "" && inpUser != "" && _empID != "") {
            // Set data to Check_in
            let checkInDate = {
                "counter_id": selCounter,
                "emp_id": _empID,
                "user_id": inpUser
            }

            try {
                await Axios.post("New/Counter/Check_in", checkInDate, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "200") {
                        setOpenCheckIn(false)
                        setOpenCheckInSuccess(true)
                        setSelSiteID("")
                    } else if (res.data.result_code == "201") {
                        setOpenCheckInFailed(true)
                        setSelSiteID("")
                    }
                })
            } catch (error) {
                // console.log(error)
            }
        }
    }

    // Function Breake ON
    const breakeON = async () => {
        let _counterLast = dataCheckIn[dataCheckIn.length - 1];
        let _counterID = _counterLast.counter_id;

        if (_counterID != "") {
            try {
                // Set Breake Data
                let breakeData = {
                    "counter_id": _counterID
                }

                await Axios.post("Update/Counter/Status/Breake/On", breakeData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "200") {
                        setOpenBreakeOn(false)
                        setOpenBreakeONSuccess(true)
                    } else if (res.data.result_code == "201") {
                        setOpenBreakeONFailed(true)
                    }
                })
            } catch (error) {
                // console.log(error)
            }
        }
    }

    // Function Breake OFF
    const breakeOFF = async () => {
        let _counterLast = dataCheckIn[dataCheckIn.length - 1];
        let _counterID = _counterLast.counter_id;

        if (_counterID != "") {
            try {
                // Set Breake Data
                let breakeData = {
                    "counter_id": _counterID
                }

                await Axios.post("Update/Counter/Status/Breake/Off", breakeData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "200") {
                        setOpenBreakeOff(false)
                        setOpenBreakeOFFSuccess(true)
                    } else if (res.data.result_code == "201") {
                        setOpenBreakeOFFFailed(true)
                    }
                })
            } catch (error) {
                // console.log(error)
            }
        }
    }

    // Function for Check-out
    const saveCheckOUT = async () => {
        let _counterLast = dataCheckIn[dataCheckIn.length - 1];
        let _counterID = _counterLast.counter_id;

        if (_empID != '' && _counterID != '') {
            // Set Check-out Data
            let checkOutDate = {
                "counter_id": _counterID,
                "emp_id": _empID
            }

            try {
                await Axios.post("Update/Counter/Check_out", checkOutDate, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "200") {
                        setOpenCheckOut(false)
                        setOpenCheckOutSuccess(true)
                    } else if (res.data.result_code == "201") {
                        setOpenCheckOutFailed(true)
                    }
                })
            } catch (error) {
                // console.log(error)
            }

        }
    }

    return (
        <>
            {loading ? <>
                <div className='manage_loading'>
                    <FadeLoader color={'#ED1C24'} loading={loading} size={10} />
                </div>
            </> : <>
                <div className='manage_title'>ຂໍ້ມູນການປະຈໍາປ່ອງບໍລິການ <span className='manage_title_date'>{_charDay}, {_showDate}</span></div>

                <Paper elevation={10} style={paperStyle} className='manage_paper'>
                    <Grid container>
                        <Grid item xs={2}>
                            <Grid item xs={10} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ລະຫັດພະນັກງານ:</span>
                            </Grid>

                            <Grid item xs={10}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    value={_empCode}
                                    disabled
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <Grid item xs={12} style={{ marginBottom: 10 }}>
                                <span className='manage_input_label'>ຊື່ ແລະ ນາມສະກຸນ:</span>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField
                                    autoComplete='off'
                                    className='form-control mt-1'
                                    id="input-with-icon-textfield"
                                    size='small'
                                    variant='outlined'
                                    fullWidth
                                    value={_empFull}
                                    disabled
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={6}>
                            {dataCheckIn && dataCheckIn.length > 0 ?
                                <>
                                    {dataCheckIn[dataCheckIn.length - 1].status_name == 'available' ? <>
                                        <Grid container>
                                            <Grid xs={3}></Grid>
                                            <Grid xs={4} style={{ marginTop: 33 }}>
                                                <Button className="manage_breake_button" fullWidth variant="outlined" onClick={() => { setOpenBreakeOn(true) }}>Breake</Button>
                                            </Grid>
                                            <Grid xs={1}></Grid>
                                            <Grid xs={4} style={{ marginTop: 33 }}>
                                                <Button className="manage_check_out_button" fullWidth variant="outlined" onClick={() => { setOpenCheckOut(true) }}>Check-out</Button>
                                            </Grid>
                                        </Grid>
                                    </> : dataCheckIn[dataCheckIn.length - 1].status_name == 'breake' ? <>
                                        <Grid container>
                                            <Grid xs={8}></Grid>
                                            <Grid xs={4} style={{ marginTop: 33 }}>
                                                <Button className="manage_cancel_breake_button" fullWidth variant="outlined" onClick={() => { setOpenBreakeOff(true) }}>Cancel Breake</Button>
                                            </Grid>
                                        </Grid>
                                    </> : dataCheckIn[dataCheckIn.length - 1].status_name == 'close' ? <>
                                        <Grid container>
                                            <Grid xs={8}></Grid>
                                            <Grid xs={4} style={{ marginTop: 33 }}>
                                                <Button className="manage_check_in_button" fullWidth variant="outlined" onClick={(e) => { setOpenSelectSite(true) }}>Check-in</Button>
                                            </Grid>
                                        </Grid>
                                    </> : <></>}
                                </> : <>
                                    <Grid container>
                                        <Grid xs={8}></Grid>
                                        <Grid xs={4} style={{ marginTop: 33 }}>
                                            <Button className="manage_check_in_button" fullWidth variant="outlined" onClick={(e) => { setOpenSelectSite(true) }}>Check-in</Button>
                                        </Grid>
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Grid>
                </Paper>

                {dataCheckIn && dataCheckIn.length > 0 ?
                    <>
                        <Paper elevation={10} style={paperStyle} className='manage_paper'>
                            <div className='manage_title'>ຂໍ້ມູນການລົງເວລາ</div>
                            <Grid container>
                                <Grid item xs={6}>
                                    <div className='manage_tab_input'>
                                        <Grid item xs={11} style={{ marginBottom: 10 }}>
                                            <span className='manage_input_label'>ພິກັດແຂວງ:</span>
                                        </Grid>

                                        <Grid item xs={11}>
                                            <TextField
                                                autoComplete='off'
                                                className='form-control mt-1'
                                                id="input-with-icon-textfield"
                                                size='small'
                                                variant='outlined'
                                                fullWidth
                                                value={dataProv}
                                                disabled
                                            />
                                        </Grid>
                                    </div>
                                </Grid>

                                <Grid item xs={6}>
                                    <div className='manage_tab_input'>
                                        <Grid container>
                                            <Grid item xs={1}></Grid>
                                            <Grid item xs={11} style={{ marginBottom: 10 }}>
                                                <span className='manage_input_label'>ພິກັດສູນບໍລິການ:</span>
                                            </Grid>

                                            <Grid item xs={1}></Grid>
                                            <Grid item xs={11}>
                                                <TextField
                                                    autoComplete='off'
                                                    className='form-control mt-1'
                                                    id="input-with-icon-textfield"
                                                    size='small'
                                                    variant='outlined'
                                                    fullWidth
                                                    value={dataSite}
                                                    disabled
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} style={{ marginTop: 20 }}>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ລໍາດັບ</span></TableCell>
                                                <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ຊື່ປ່ອງບໍລິການ</span></TableCell>
                                                <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ປະເພດບໍລິການ</span></TableCell>
                                                <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>Check-in</span></TableCell>
                                                <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>Check-out</span></TableCell>
                                                <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ສະຖານະປ່ອງ</span></TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {dataCheckIn && dataCheckIn.length > 0 ?
                                                <>
                                                    {dataCheckIn.map((row, idx) => (
                                                        <TableRow key={idx}>
                                                            <TableCell align='center'><span className='manage_table_data'>{idx + 1}</span></TableCell>
                                                            <TableCell align='left'><span className='manage_table_data'>{row.counter_name}</span></TableCell>
                                                            <TableCell align='left'><span className='manage_table_data'>{row.counter_type}</span></TableCell>
                                                            <TableCell align='center'><span className='manage_table_data'>{dateFormat(row.check_in, "dd/mm/yyyy HH:MM:ss")}</span></TableCell>
                                                            <TableCell align='center'>
                                                                <span className='manage_table_data'>
                                                                    {row.check_out == null ? <>...</> : <>
                                                                        {dateFormat(row.check_out, "dd/mm/yyyy HH:MM:ss")}
                                                                    </>}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell align='center'>
                                                                <span className='manage_table_data'>
                                                                    {row.check_out != null ? <>
                                                                        <button className='check-in_status_close'>{"close"}</button>
                                                                    </> : row.status_name == 'close' ? <>
                                                                        <button className='check-in_status_close'>{row.status_name}</button>
                                                                    </> : row.status_name == 'available' ? <>
                                                                        <button className='check-in_status_available'>{row.status_name}</button>
                                                                    </> : row.status_name == 'progress' ? <>
                                                                        <button className='check-in_status_progress'>{row.status_name}</button>
                                                                    </> : row.status_name == 'breake' ? <>
                                                                        <button className='check-in_status_breake'>{row.status_name}</button>
                                                                    </> : <></>}
                                                                </span>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </> : <>
                                                    <TableBody>
                                                        <TableCell style={{ justifyContent: "center", alignItems: 'center' }}>No Data...</TableCell>
                                                    </TableBody>
                                                </>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Paper>
                    </> : <></>
                }

                {/* Dialog Select Site */}
                <Dialog
                    fullWidth={true}
                    open={openSelectSite}
                    maxWidth={"sm"}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialog_title'>
                            ເລືອກສູນບໍລິການທີ່ຈະ Check-in
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ marginBottom: 20 }}>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField id="limit" variant="outlined" size="small" select onChange={filterProvince}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ເລືອກແຂວງ:</InputAdornment>
                                            }}
                                            fullWidth>
                                            {selProv.map((option) => (
                                                <MenuItem key={option.prov_id} value={option.prov_name}>
                                                    {option.prov_name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </div>

                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField id="limit" variant="outlined" size="small" select onChange={filterSite}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ເລືອກສູນບໍລິການ:</InputAdornment>
                                            }}
                                            fullWidth>
                                            {foundSite.map((option) => (
                                                <MenuItem key={option.site_id} value={option.site_id}>
                                                    {option.site_name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_saveBtn' onClick={checkIN}>
                                        ຖັດໄປ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_cancelBtn' onClick={() => { setOpenSelectSite(false); setSelSiteID("") }}>
                                        ຍົກເລີກ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Check-in */}
                <Dialog
                    fullWidth={true}
                    open={openCheckIn}
                    maxWidth={"sm"}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialog_title'>
                            ຂໍ້ມູນການ Check-in ສູນບໍລິການ
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ marginBottom: 20 }}>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ພິກັດແຂວງ:</InputAdornment>
                                            }}
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            value={provName}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">ພິກັດສູນບໍລິການ:</InputAdornment>
                                            }}
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            value={siteName}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>
                            </div>

                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <span className='manage_dialog_label'>ເລືອກປ່ອງບໍລິການ:</span>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField id="limit" variant="outlined" size="small" select fullWidth onChange={(e) => { setSelCounter(e.target.value) }}>
                                            {dataCounter.map((option) => (
                                                <MenuItem key={option.counter_id} value={option.counter_id}>
                                                    {option.counter_name + " (" + option.counter_type + ")"}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </div>

                            <div className='manage_dialog_content'>
                                <Grid container>
                                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                                        <span className='manage_dialog_label'>ປ້ອນລະຫັດ User:</span>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            autoComplete='off'
                                            className='form-control mt-1'
                                            id="input-with-icon-textfield"
                                            size='small'
                                            variant='outlined'
                                            fullWidth
                                            onChange={(e) => { setInpUser(e.target.value) }}
                                        />
                                    </Grid>
                                </Grid>
                            </div>


                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_saveBtn' onClick={saveCheckIN}>
                                        ບັນທຶກ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_cancelBtn' onClick={() => { setOpenCheckIn(false); setSelCounter(""); setInpUser(""); setSelSiteID("") }}>
                                        ຍົກເລີກ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Check-in Success */}
                <Dialog
                    fullWidth={true}
                    open={openCheckInSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_success} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ທ່ານ Check-in ສໍາເລັດແລ້ວ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_successBtn' onClick={() => { setOpenCheckInSuccess(false); history.go(0) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert This Counter Already Check-in */}
                <Dialog
                    fullWidth={true}
                    open={openCheckInFailed}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ຂໍອະໄພ ປ່ອງບໍລິການນີ້ມີຄົນ Check-in ໄປແລ້ວ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenCheckInFailed(false) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Not Counter Available */}
                <Dialog
                    fullWidth={true}
                    open={openErrorCounter}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ຂໍອະໄພ...ບໍ່ສາມາດ Check-in ໄດ້ເນື່ອງຈາກ Counter ໃນສູນຂອງທ່ານເຕັມໝົດແລ້ວ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenErrorCounter(false) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Outsite of Location */}
                <Dialog
                    fullWidth={true}
                    open={openOutSite}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ຂໍອະໄພ ທ່ານຢູ່ນອກສະຖານທີສູນບໍລິການ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenOutSite(false) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Breake ON */}
                <Dialog
                    fullWidth={true}
                    open={openBreakeOn}
                    maxWidth={"sm"}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialog_title'>
                            Breake ພັກປ່ອງບໍລິການຊົ່ວຄາວ
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ marginBottom: 20 }}>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialog_content'>
                                <span>ທ່ານຕ້ອງການ Breake ປ່ອງບໍລິການນີ້ ຫຼື ບໍ່ ?</span>
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_saveBtn' onClick={breakeON}>
                                        ຕົກລົງ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_cancelBtn' onClick={() => { setOpenBreakeOn(false); }}>
                                        ຍົກເລີກ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Breake ON Success */}
                <Dialog
                    fullWidth={true}
                    open={openBreakeONSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_success} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ທ່ານໄດ້ພັກ Breake ປ່ອງບໍລິການນີ້ແລ້ວ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_successBtn' onClick={() => { setOpenBreakeONSuccess(false); history.go(0) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Breake ON Failed */}
                <Dialog
                    fullWidth={true}
                    open={openBreakeONFailed}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ບໍ່ສາມາດພັກ Breake ໄດ້ຕອນນີ້ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenBreakeONFailed(false) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Breake OFF */}
                <Dialog
                    fullWidth={true}
                    open={openBreakeOff}
                    maxWidth={"sm"}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialog_title'>
                            ຍົກເລີກການ Breake ພັກປ່ອງບໍລິການຊົ່ວຄາວ
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ marginBottom: 20 }}>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialog_content'>
                                <span>ທ່ານຕ້ອງການຍົກເລີກການ Breake ປ່ອງບໍລິການນີ້ ຫຼື ບໍ່ ?</span>
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_saveBtn' onClick={breakeOFF}>
                                        ຕົກລົງ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_cancelBtn' onClick={() => { setOpenBreakeOff(false); }}>
                                        ຍົກເລີກ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Breake OFF Success */}
                <Dialog
                    fullWidth={true}
                    open={openBreakeOFFSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_success} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ທ່ານໄດ້ຍົກເລີກການພັກ Breake ປ່ອງບໍລິການນີ້ແລ້ວ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_successBtn' onClick={() => { setOpenBreakeOFFSuccess(false); history.go(0) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Breake OFF Failed */}
                <Dialog
                    fullWidth={true}
                    open={openBreakeOFFFailed}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ບໍ່ສາມາດຍົກເລີກການ Breake ໄດ້ ລອງໃຫມ່ອີກຄັ້ງ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenBreakeOFFFailed(false) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Check-out */}
                <Dialog
                    fullWidth={true}
                    open={openCheckOut}
                    maxWidth={"sm"}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialog_title'>
                            ຂໍ້ມູນການ Check-out ສູນບໍລິການ
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ marginBottom: 20 }}>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialog_content'>
                                <span>ທ່ານຕ້ອງການ Check-out ອອກຈາກປ່ອງບໍລິການຕອນນີ້ ຫຼື ບໍ່ ?</span>
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_saveBtn' onClick={saveCheckOUT}>
                                        ບັນທຶກ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_cancelBtn' onClick={() => { setOpenCheckOut(false); }}>
                                        ຍົກເລີກ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Check-out Success */}
                <Dialog
                    fullWidth={true}
                    open={openCheckOutSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_success} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ທ່ານ Check-out ສໍາເລັດແລ້ວ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_successBtn' onClick={() => { setOpenCheckOutSuccess(false); history.go(0) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Check-out Failed */}
                <Dialog
                    fullWidth={true}
                    open={openCheckOutFailed}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ບໍ່ສາມາດ Check-out ໄດ້ ລອງໃຫມ່ອີກຄັ້ງ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenCheckOutFailed(false) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

            </>}
        </>
    )
}

export default CheckList